import React, { useState, useEffect, useRef, useContext } from 'react';
import Quill from 'quill';
import 'quill/dist/quill.snow.css';
import { createArticle, deleteImage, uploadImage } from './api/articleApi';
import { AuthContext } from './context/authContext';

function Editor() {
  const { user } = useContext(AuthContext);
  const [content, setContent] = useState(''); // Состояние для контента
  const [title, setTitle] = useState(''); // Состояние для заголовка
  const [titleBe, setTitleBe] = useState('');
  const [contentBe, setContentBe] = useState('');
  const [articleType, setArticleType] = useState('новость');
  const quillRef = useRef(null); // Реф для Quill
  const quillRefBe = useRef(null);

  useEffect(() => {
    if (!quillRef.current) {
      const quill = new Quill('#editor-ru', {
        theme: 'snow',
      });

      quillRef.current = quill;

      quill.on('text-change', () => {
        const newContent = quill.root.innerHTML;
        setContent(newContent);
        saveToLocalStorage('article-content', newContent);
      });
    }

    if (!quillRefBe.current) {
      const quill = new Quill('#editor-be', { theme: 'snow' });
      quillRefBe.current = quill;

      quill.on('text-change', () => {
        const html = quill.root.innerHTML;
        setContentBe(html);
        localStorage.setItem('article-content-be', html);
      });
    }
  }, []);

  const saveToLocalStorage = (key, value) => {
    localStorage.setItem(key, value);
  };

  const loadFromLocalStorage = (key) => {
    return localStorage.getItem(key) || '';
  };

  useEffect(() => {
    const savedTitle = loadFromLocalStorage('article-title');
    const savedContent = loadFromLocalStorage('article-content');

    setTitle(savedTitle);
    setContent(savedContent);
    setTitleBe(localStorage.getItem('article-title-be') || '');
    setContentBe(localStorage.getItem('article-content-be') || '');

    if (quillRef.current) {
      quillRef.current.root.innerHTML = savedContent || '';
    }

    if (quillRefBe.current) {
      quillRefBe.current.root.innerHTML = localStorage.getItem('article-content-be') || '';
    }
  }, []);

  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    try {
      const data = await uploadImage(file, user.token);
      const imagePath = data.filePath;

      const quills = [quillRef.current, quillRefBe.current];
      quills.forEach((quill) => {
        if (!quill) return;

        quill.focus();
        const range = quill.getSelection(true);
        const index = range ? range.index : quill.getLength();

        quill.insertEmbed(index, 'image', imagePath);
        quill.setSelection(index + 1);
      });
    } catch (error) {
      alert('Ошибка загрузки изображения: ' + error.message);
    }
  };

  const handleSubmit = async () => {
    if (!title.trim() || !titleBe.trim()) {
      alert('Заполните заголовки на обоих языках');
      return;
    }

    const currentContent = quillRef.current?.root.innerHTML || '';
    const currentContentBe = quillRefBe.current?.root.innerHTML || '';

    try {
      console.log(currentContentBe);
      const data = await createArticle(
        title,
        currentContent,
        titleBe,
        currentContentBe,
        articleType,
        user.token,
      );
      localStorage.removeItem('article-title');
      localStorage.removeItem('article-content');
      localStorage.removeItem('article-title-be');
      localStorage.removeItem('article-content-be');

      window.location.href = data.url;
    } catch (error) {
      alert('Ошибка при публикации статьи. Попробуйте еще раз.');
    }
  };

  return (
    <div className="editor-page-container">
      <h1>Создание статьи</h1>

      <h3>Тип статьи</h3>
      <div className="radio-group">
        <label>
          <input
            type="radio"
            value="новость"
            checked={articleType === 'новость'}
            onChange={() => setArticleType('новость')}
          />
          <span>Новость</span>
        </label>
        <label>
          <input
            type="radio"
            value="статья"
            checked={articleType === 'статья'}
            onChange={() => setArticleType('статья')}
          />
          <span>Статья</span>
        </label>
      </div>

      <div className="uploads" style={{ margin: '20px 0' }}>
        <input type="file" accept="image/png, image/jpeg, image/jpg" onChange={handleImageUpload} />
        <p>
          Вы можете загрузить изображения (.png, .jpg, .jpeg) Они будут отображены в двух языковых
          версиях.
        </p>
      </div>

      <h3>Русская версия</h3>
      <input
        type="text"
        className="article-title-input"
        value={title}
        onChange={(e) => {
          setTitle(e.target.value);
          localStorage.setItem('article-title', e.target.value);
        }}
        placeholder="Введите заголовок на русском"
      />

      <div id="editor-ru"></div>
      <div dangerouslySetInnerHTML={{ __html: `<hr class="editor-divider" />` }}></div>

      <h3>Беларуская версія</h3>
      <input
        type="text"
        value={titleBe}
        className="article-title-input"
        onChange={(e) => {
          setTitleBe(e.target.value);
          localStorage.setItem('article-title-be', e.target.value);
        }}
        placeholder="Увядзіце загаловак па-беларуску"
      />
      <div id="editor-be"></div>

      <button onClick={handleSubmit} style={{ marginTop: '20px' }}>
        Опубликовать
      </button>
    </div>
  );
}

export default Editor;
